import { useQuery } from 'react-query'
import http from 'services/http'

export const useProductsSupportEnabled = () =>
  useQuery(
    'products-support-enabled',
    async () => (await http.get<number[]>('/cliente/produtos_habilitados_assistencia')).data
  )
